import { Dialog, IconButton, ModalOverlay, ModalPrimitive } from "@wayflyer/flyui";
import { IconXmark24Line } from "@wayflyer/flyui-icons/24/line";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import styles from "./dialog.module.css";

interface VideoDialogProps {
  title: string;
  children: ReactNode;
  onClose: () => void;
}

export function VideoDialog({ title, children, onClose }: VideoDialogProps) {
  const intl = useIntl();

  return (
    <ModalOverlay isDismissable $motionState="entered" className={styles.overlay} data-testid="video-overlay">
      <ModalPrimitive $motionState="entered" className={styles.content}>
        <Dialog aria-label={title} className={styles.dialog}>
          {children}
          <IconButton
            Icon={IconXmark24Line}
            accessibilityLabel={intl.formatMessage({ id: "funder: close video", defaultMessage: "Close video" })}
            variant="GhostOnInverse"
            size="md"
            tooltip={{ enabled: false }}
            className={styles.close}
            onClick={onClose}
          />
        </Dialog>
      </ModalPrimitive>
    </ModalOverlay>
  );
}
